import { createApp } from "vue";
import { RotateCw } from "lucide-vue-next";
import { createVueUi } from "@lunagoai/vue-ui";
import "@lunagoai/vue-ui/style.css";
import App from "./App.vue";
import "./assets/main.css";
import { installPreloadRecovery, registerPwa } from "./lib/pwa";
import { posnextVueUiTheme } from "./lib/vue-ui-theme";

installPreloadRecovery();
createApp(App).use(createVueUi({ icons: { RotateCw }, theme: posnextVueUiTheme })).mount("#app");
registerPwa("/sw.js");
